import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ExperienceBoundary from './components/ui/ExperienceBoundary';

// A fresh application: the first visit after a data reset forgets everything
// the browser kept for the old one (tokens, demo flag, saved filters, drafts).
const RESET_MARK = '2026-10-14';
try {
  if (localStorage.getItem('cw_reset') !== RESET_MARK) {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('cw_reset', RESET_MARK);
  }
} catch (e) { /* private window or storage blocked: nothing to forget */ }

const root = ReactDOM.createRoot(document.getElementById('root'));

// Render first, always. Priming the pipeline cache before the first paint made
// the app fetch batches while signed out, and the API client answers 401 by
// navigating to /login, which reloaded the page and fetched again: a loop that
// never rendered anything.
import('./App')
  .then(({ default: App }) => root.render(
    <React.StrictMode>
      <ExperienceBoundary resetKey="application-root"><App /></ExperienceBoundary>
    </React.StrictMode>
  ))
  .catch((error) => {
    console.error('Application startup error', error);
    root.render(<pre style={{ padding: 24, color: '#b91c1c' }}>{String(error?.stack || error)}</pre>);
  });
